// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getDatabase } from 'firebase/database';


const firebaseConfig = {
  apiKey: "AIzaSyDWDd2O3uUQUqn3e3mHQs-jCrK2chSEgMw",
  authDomain: "mailexmax.firebaseapp.com",
  projectId: "mailexmax",
  storageBucket: "mailexmax.firebasestorage.app",
  messagingSenderId: "548926208060",
  appId: "1:548926208060:web:877c11290a626418476b39",
  measurementId: "G-0NQ1B6KQ0E"
};

  const app = initializeApp(firebaseConfig);
  const database = getDatabase(app);
  const db = getFirestore(app);
export const auth = getAuth(app);
export { db, database };
